import {Component, Vue} from 'vue-property-decorator';
import moment from "moment";

@Component
export default class datepickerMixin extends Vue {

    $_datepickerMixin_customFormatter(dateString): string | number | null {
        if (moment(dateString, 'MM/DD/YY',true).isValid()) {
            return moment(dateString).format('MM/DD/YY')
        } else if (typeof dateString ==='number') {
            return dateString;
        }else {
            return "";
        }
    }
}
